<template>
    <div class="footer-panel" :style="footerBg">
        <div class="footer-panel-img">
            <a href="http://bszs.conac.cn/sitename?method=show&id=54412A215B893ACCE053012819AC7144"><img src="@/assets/images/home/footer-img.png"></a>
        </div>
        
        <div class="footer-panel-message">
            <p title="主办单位：中共深圳市委组织部">主办单位：中共深圳市委组织部&nbsp;&nbsp;&nbsp;&nbsp;技术支持：广东邮电职业技术学院</p>
            <p title="服务电话：020-38253001       服务QQ：2287301283    服务微信号：13392604886    联系邮箱：wlxy@gd.gov.cn">服务电话：020-38253001&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;服务微信号：13392604886&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系邮箱：wlxy@gd.gov.cn</p>
            <p title="建议使用1024*768分辨率IE9以上版本浏览器   推荐使用谷歌浏览器或者360浏览器极速模式">建议使用1024*768分辨率IE9以上版本浏览器&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;推荐使用谷歌浏览器或者360浏览器极速模式</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MenuFooter',
    data() {
        return {
            footerBg: {
                backgroundImage: "url(" + require("../assets/images/home/footer.png") + ")",
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
            }
        }
    }
}
</script>

<style>

.footer-panel {
    /* width: 100vw; */
    min-width:1024px;
    padding: 10px 0;
    font-size: 10px;
    font-weight: normal;
    color: #fff1ed;
    text-align: center;
    overflow: hidden;
}
.footer-panel-img {
    display: inline-block;
}
.footer-panel-img img {
    width: 4vw;
    min-width: 65px;
    position: relative;
    top: 10px;
    left: 5px;
}
.footer-panel-message {
    /* width: 35vw; */
    /* min-width: 537px; */
    display: inline-block;
}
.footer-panel-message p {
    margin: 0.3vw;
    text-align: left;
}

</style>


// WEBPACK FOOTER //
// src/components/MenuFooter.vue


// WEBPACK FOOTER //
// src/components/MenuFooter.vue